import { render, staticRenderFns } from "./SeanceList.vue?vue&type=template&id=4e04cf60&"
import script from "./SeanceList.vue?vue&type=script&lang=js&"
export * from "./SeanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports